import ContratoInterceptor from '../ContratoInterceptor'

const api = new ContratoInterceptor()

export default {
  addGestores(contratoId: String, gestores) {
    return api.post(`/contratos/${contratoId}/gestores`, gestores)
  },

  deleteGestor(contratoId: String, gestorId) {
    return api.delete(`/contratos/${contratoId}/gestores/${gestorId}`)
  },

  getGestores() {
    return api.get(`/gestores`)
  },
}
